import React from 'react';
import {makeObservable} from 'mobx';
import {observer} from 'mobx-react';
import s from '../../s';
import ATCButton from './atc-button';
import PromoRedeem from '../promo-redeem';
import * as util from '../../../util';
import ShareIcon from '../share-icon';

declare const modalOpen: (id: string) => void;

interface IATCProps {
    lite?: boolean;
}

@observer
export default class ATC extends React.Component<IATCProps> {
    constructor(props: IATCProps) {
        super(props);
        makeObservable(this);
    }

    render() {
        return (
            <div className="position-relative">
                <div className="atc-lg">
                    <div className="atc-buttons-container">
                        <ATCButton additionalClass={this.props.lite ? 'sm' : 'lg'} />

                        {/* {AbTestStore.ABIsVariant(ABTestKeys.prod_buynow, 1)) && !s.prod.categories?.length && (
                            <ATCButton
                                label="Buy now"
                                buyNow={true}
                                additionalClass={'buy-now'}
                            />
                        )} */}
                    </div>

                    {!s.IsPortal3 && !this.props.lite && s.isRetail && (
                        <div className="return">
                            <button
                                className="link link-btn"
                                onClick={() => modalOpen('modal-return-policy')}
                                type="button"
                                aria-label="View information about return policy"
                                aria-haspopup="dialog"
                                aria-controls="modal-return-policy"
                            >
                                Easy, {s.PortalID < 3 ? '120' : '30'}-day return policy
                            </button>
                        </div>
                    )}

                    {s.ui.show_atc && (
                        <div className="sticky-atc">
                            <ATCButton additionalClass="sticky" />
                        </div>
                    )}

                    {s.ui.show_atc && s.pcs.atc_error && s.pcs.atc_error !== '' && (
                        <div className="alert alert-danger mt-1">
                            <b>Error</b>
                            <div className="mt-2">{s.pcs.atc_error}</div>
                        </div>
                    )}

                    <PromoRedeem />
                </div>

                {!s.IsPortal3 && window.innerWidth > 1200 && (
                    <div style={{position: 'absolute', top: 8, left: 0}}>
                        <ShareIcon />
                    </div>
                )}
            </div>
        );
    }
}
